import { Nullable } from '@ui/types/utility';
import { isNil } from 'lodash-es';

export const getTpQuickRatios = (maxTpRatios: Nullable<number>) => {
  if (isNil(maxTpRatios) || maxTpRatios > 5) {
    return [1, 2, 3, 4, 5];
  }

  return [1, 1.5, 2, 2.5, 3];
};

export const getTpQuickMaxRatio = (maxTpRatios: Nullable<number>) => {
  const ratios = getTpQuickRatios(maxTpRatios);

  return ratios[ratios.length - 1];
};
